
            const data = {"name":"plus-circle","data":{"viewBox":"0 0 60 60","data":"<path pid=\"0\" d=\"M30 1a29 29 0 1029 29A29 29 0 0030 1zm7.6 30.24h-5.74V37H29.5v-5.76h-5.74v-2.36h5.74v-5.74h2.36v5.74h5.74z\" _fill=\"#171614\"/>","originalColors":[{"type":"fill","color":"#171614"}],"stopColors":[]}}
        
                module.exports = data
                